module.exports = __webpack_public_path__ + "static/img/锻造自动化生产线.97b3f768.png";